import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Shield, Mail, Phone, BadgeCheck, MapPin } from 'lucide-react';
import './AdminProfile.css';

const AdminProfile = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    name: 'Admin User',
    email: 'admin@shyamagro.com',
    role: 'admin',
    mobile: '9912649265',
    address: 'Opposite New Bustand, Nandikotkur (TQ), Nandyal (DT) - 518401',
    permissions: []
  });

  useEffect(() => {
    const storedName = localStorage.getItem('adminName') || 'Admin User';
    const storedEmail = localStorage.getItem('adminEmail') || 'admin@shyamagro.com';
    let storedRole = localStorage.getItem('adminRole') || 'admin';
    const storedPerms = localStorage.getItem('adminPermissions');
    const storedAddress = localStorage.getItem('adminAddress') || 'Opposite New Bustand, Nandikotkur (TQ), Nandyal (DT) - 518401';
    
    // Attempt to match from local staff list to pull phone if available
    const localAccounts = JSON.parse(localStorage.getItem('added_staff_accounts') || '[]');
    const matched = localAccounts.find(acc => acc.email.toLowerCase() === storedEmail.toLowerCase());

    setUser({
      name: storedName,
      email: storedEmail,
      role: storedRole,
      mobile: matched?.mobile || '9912649265',
      address: storedAddress || matched?.address || 'Opposite New Bustand, Nandikotkur (TQ), Nandyal (DT) - 518401',
      permissions: storedPerms ? JSON.parse(storedPerms) : (matched?.permissions || [])
    });
  }, []);

  const getRoleLabel = (role) => {
    switch (role?.toLowerCase()) {
      case 'super admin':
      case 'superadmin':
        return 'Super Administrator';
      case 'admin':
      case 'administrator':
        return 'Admin';
      case 'manager': return 'Operations Manager';
      case 'staff': return 'Staff Member';
      default: return 'Admin';
    }
  };

  return (
    <div className="admin-profile-container">
      {/* Top Header Card */}
      <section className="profile-header-card">
        <div className="profile-header-left">
          <div className="profile-avatar">
            {user.name.charAt(0).toUpperCase()}
          </div>
          <div className="profile-title-details">
            <span className="profile-kicker" style={{ color: '#cbd5e1' }}>Account Profile</span>
            <h2 style={{ color: '#ffffff', margin: 0, fontWeight: 800 }}>{user.name}</h2>
            <div className="profile-badge-row">
              <span className={`role-badge ${user.role.replace(' ', '-')}`}>
                <Shield size={12} /> {getRoleLabel(user.role)}
              </span>
              <span className="status-badge-active">
                <BadgeCheck size={12} /> Active Session
              </span>
            </div>
          </div>
        </div>
        <button 
          className="edit-profile-btn"
          onClick={() => navigate('/admin/account-settings')}
        >
          Account Settings
        </button>
      </section>

      {/* Main Details Grid */}
      <div className="profile-details-grid">
        {/* Left Column: Account Details */}
        <div className="profile-card">
          <h3>Personal Details</h3>
          <div className="detail-item">
            <span className="detail-label"><User size={16} /> Full Name</span>
            <span className="detail-value">{user.name}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label"><Mail size={16} /> Email Address</span>
            <span className="detail-value">{user.email}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label"><Phone size={16} /> Mobile Number</span>
            <span className="detail-value">{user.mobile ? (user.mobile.startsWith('+91') ? user.mobile : `+91 ${user.mobile.replace(/^\+?91\s*/, '')}`) : 'N/A'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label"><MapPin size={16} /> Address</span>
            <span className="detail-value">{user.address || 'Opposite New Bustand, Nandikotkur (TQ), Nandyal (DT) - 518401'}</span>
          </div>
        </div>

        {/* Right Column: RBAC Info */}
        <div className="profile-card">
          <h3>System Access Permissions</h3>
          <p className="perms-intro-text">
            Below are the administrative modules you currently have access to:
          </p>
          <div className="permission-tags-container">
            {user.role === 'super admin' ? (
              <div className="all-access-tag">
                <Shield size={16} /> Full System Access Granted (All Screens)
              </div>
            ) : user.permissions.length > 0 ? (
              user.permissions.map(perm => (
                <span key={perm} className="permission-tag">
                  {perm.replace('-', ' ')}
                </span>
              ))
            ) : (
              <span className="no-perms-text">No custom permissions explicitly granted. Default role access applies.</span>
            )}
          </div>
          
          <div className="profile-warning-box">
            <strong>Security Notice:</strong> Your permissions are controlled by the System Administrator. To request additional scope grants, please contact support.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminProfile;
